export default __webpack_public_path__ + "static/char-v-31-jam-16dca09e50111ff67006bc5ab19b2083.mp4";